import React from 'react';
import Knob from '../Knob';
import { Label } from '../Label';
import styles from './personalisation-text.module.css';
import { useViewModel } from './useViewModel';

/**
 * PersonalisationText molecule: câmp pentru text personalizat (ex: mesaj cadou)
 * Props:
 *  - value: string
 *  - onChange: (val: string) => void
 *  - maxLength: number (default 16)
 *  - required: boolean (default true)
 *  - disabled: boolean
 *  - label: string (default 'Enter Personalisation Text')
 *  - placeholder: string (fallback e.g. Happy Birthday... cu maxLength)
 *  - helperText: string (opțional, text informativ sub câmp)
 */
export function PersonalisationText({
  price = 5,
  title = 'Add personalised text',
  placeholder = 'e.g. Happy Birthday, etc. (16 chars max)',
  maxLength = 16,
  required = true,
  enabled: enabledProp,
  onToggle,
  text: textProp,
  onTextChange,
  className = '',
  itemType = 'bag',
  ...props
}) {
  const { enabled, text, handleToggle, handleChange, handleKeyDown, formatPrice, textMap } = useViewModel({
    enabledProp,
    textProp,
    onToggle,
    onTextChange
  });
  return (
    <div className={`${styles.card} ${enabled ? styles.enabled : ''} ${className}`} {...props}>
      <div className={styles.headerRow}>
        <div className={styles.titles}>
          <div className={styles.titleRow}>
            <h4 className={styles.title}>{title}</h4>
            <span className={styles.price}>{formatPrice({ amount: price })}</span>
          </div>
          {textMap[`${itemType}`] && <p className={styles.desc}>{textMap[`${itemType}`]}</p>}
        </div>
        <Knob
          isEnabled={enabled}
          onChange={() => handleToggle(!enabled)}
          aria-label={`${enabled ? 'Remove' : 'Add'} personalised text`}
        />
      </div>

      {enabled && (
        <div className={styles.body}>
          <Label htmlFor="personalisation-text" className={styles.inputLabel}>
            Enter Personalisation Text {required && <span className={styles.req}>*</span>}
          </Label>
          <div className={styles.inputWrap}>
            <input
              id="personalisation-text"
              type="text"
              className={styles.input}
              placeholder={placeholder}
              value={text}
              maxLength={maxLength}
              onChange={(e) => handleChange(e.target.value)}
              onKeyDown={(e) => {
                if (handleKeyDown(e)) {
                  e.preventDefault();
                }
              }}
            />
            <span className={styles.counter}>
              {text.length}/{maxLength}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default PersonalisationText;
